import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@mui/styles';
import { Card, CardHeader, CardContent, Divider } from '@mui/material';

import { GenericMoreButton } from 'components';
import { Chart } from './components';

const useStyles = makeStyles((theme) => ({
	root: {},
	content: {},
	buttons: {
		display: 'flex',
		justifyContent: 'center',
		'& > *': {
			marginLeft: theme.spacing(1),
		},
	},
	inner: {
		height: 375,
		minWidth: 500,
	},
	chart: {
		height: '100%',
	},
}));

const PerformanceOverTime = (props) => {
	const { className, ...rest } = props;

	const classes = useStyles();

	const data = {
		thisWeek: {
			data: [],
			labels: [],
		},
		thisMonth: {
			data: [],
			labels: [],
		},
		thisYear: {
			data: [10, 5, 11, 20, 13, 28, 18, 4, 13, 12, 13, 5],
			labels: [
				'Jan',
				'Feb',
				'Mar',
				'Apr',
				'May',
				'Jun',
				'Jul',
				'Aug',
				'Sep',
				'Oct',
				'Nov',
				'Dec',
			],
		},
	};

	return (
		<Card {...rest} className={clsx(classes.root, className)}>
			<CardHeader
				action={<GenericMoreButton />}
				title="Performance Over Time"
			/>
			<Divider />
			<CardContent className={classes.content}>
				<PerfectScrollbar>
					<div className={classes.inner}>
						<Chart
							className={classes.chart}
							data={data.thisYear.data}
							labels={data.thisYear.labels}
						/>
					</div>
				</PerfectScrollbar>
			</CardContent>
		</Card>
	);
};

PerformanceOverTime.propTypes = {
	className: PropTypes.string,
};

export default PerformanceOverTime;
